import {RouterModule, Routes} from '@angular/router';
import {IddCallsComponent} from './idd-calls/idd-calls.component';
import {IddRoamingComponent} from './idd-roaming/idd-roaming.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonComponentsModule} from '../common.module';
import {FormsModule} from '@angular/forms';
import {MatTabsModule} from '@angular/material';
import {SmsPageComponent} from './sms-page/sms-page.component';

const iddRoutes: Routes = [
  {path: 'calls', component: IddCallsComponent},
  {path: 'roaming', component: IddRoamingComponent},
  {path: 'sms', component: SmsPageComponent}
];

@NgModule({
  imports: [RouterModule.forChild(iddRoutes), CommonModule, CommonComponentsModule, FormsModule, MatTabsModule],
  declarations: [IddRoamingComponent, IddCallsComponent, SmsPageComponent],
  exports: [RouterModule]
})
export class IddModule {

}
